import "./ResightingAssignments.css";
import {
  formatLogActionLabel,
  formatLogTimeOnly,
  groupLogsByDate,
  shouldShowLogDetails,
} from "./assignmentLogUtils";

function ResightingAssignmentTimeline({ logs, isLoading, errorMessage }) {
  if (isLoading) {
    return <p className="resighting-qc-muted">Loading activity...</p>;
  }

  if (errorMessage) {
    return <p className="resighting-qc-muted">{errorMessage}</p>;
  }

  if (!logs?.length) {
    return (
      <p className="resighting-qc-muted">
        No activity recorded for this assignment yet.
      </p>
    );
  }

  const dateGroups = groupLogsByDate(logs);

  return (
    <div className="resighting-log-timeline" aria-label="Assignment activity">
      {dateGroups.map((group) => (
        <section
          key={group.dateKey}
          className="resighting-log-timeline-date-group"
          aria-label={group.dateLabel}
        >
          <h3 className="resighting-log-timeline-date">{group.dateLabel}</h3>
          <ol className="resighting-log-timeline-entries">
            {group.entries.map(({ log, index }, entryIndex) => {
              const isLastInGroup = entryIndex === group.entries.length - 1;
              const actorLabel = log.email || "Unknown user";
              const showDetails = shouldShowLogDetails(log.action, log.details);

              return (
                <li
                  key={log.id ?? `${log.timestamp}-${index}`}
                  className={`resighting-log-timeline-entry${isLastInGroup ? " resighting-log-timeline-entry--last" : ""}`}
                >
                  <span className="resighting-log-timeline-entry-time">
                    {formatLogTimeOnly(log.timestamp)}
                  </span>
                  <div className="resighting-log-timeline-marker" aria-hidden="true">
                    <span className="resighting-log-timeline-dot" />
                  </div>
                  <div className="resighting-log-timeline-entry-content">
                    <p className="resighting-log-timeline-entry-line">
                      <span className="resighting-log-timeline-actor">{actorLabel}</span>{" "}
                      <span className="resighting-log-timeline-action">
                        {formatLogActionLabel(log.action)}
                      </span>
                    </p>
                    {showDetails ? (
                      <p className="resighting-log-timeline-details">{log.details.trim()}</p>
                    ) : null}
                  </div>
                </li>
              );
            })}
          </ol>
        </section>
      ))}
    </div>
  );
}

export default ResightingAssignmentTimeline;
